<div class="container" style="position: relative">
    <div class="set">
        <div class="btns">
            <button class="me-2">
                <mat-form-field appearance="outline" class="dateinput">

                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="todayDate">

                        <input readonly matStartDate formControlName="start" placeholder="Select Dates" (dateChange)="datewiseOrder('start', $event)" (click)="picker.open()" style="cursor: pointer;" />
                        <input readonly matEndDate formControlName="end" (dateChange)="datewiseOrder('end', $event)" (click)="picker.open()" />

                    </mat-date-range-input>

                    <mat-datepicker-toggle matPrefix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>
                            <img src="../../../assets/images/calendar.svg">
                        </mat-icon>
                    </mat-datepicker-toggle>

                    
                    <button mat-icon-button matSuffix *ngIf="range.value.start || range.value.end" (click)="clearDateRange($event)" >
                        <mat-icon>close</mat-icon>
                    </button>

                    <mat-date-range-picker #picker></mat-date-range-picker>

                </mat-form-field>
            </button>

            <button class="me-2" *ngIf="isMainSuperUser">
                <mat-form-field appearance="outline">

                    <input matInput placeholder="Search Organisation" [formControl]="orgSearchControl" (input)="onOrgSearchInput($event)" [matAutocomplete]="orgAuto" />
                    <mat-icon matSuffix>search</mat-icon>

                </mat-form-field>

                <mat-autocomplete #orgAuto="matAutocomplete" (optionSelected)="onOrgSelect($event.option.value)" [displayWith]="displayOrg" >

                    <mat-option *ngFor="let org of organisations" [value]="org" [title]="org.organisationName">
                        <span class="org-option" matTooltip="{{ org.organisationName }}">
                            {{ org.organisationName }}
                        </span>
                    </mat-option>

                    <!-- Show "No results" when search has >= 3 chars but no results -->
                    <mat-option *ngIf="organisations.length === 0 && getOrgSearchInputValue().trim().length >= 3" disabled>
                        No organisations found
                    </mat-option>

                </mat-autocomplete>
            </button>

            <button class="me-2">
               <mat-form-field appearance="outline" class="search-field">

                    <input matInput placeholder="Search User" [formControl]="userSearchControl" [matAutocomplete]="userAuto" (input)="onUserSearchInput($event)" />

                    <mat-icon matSuffix>search</mat-icon>

                    
                </mat-form-field>

                <mat-autocomplete #userAuto="matAutocomplete" (optionSelected)="onUserSelect($event.option.value)" [displayWith]="displayUser">

                    <mat-option *ngFor="let item of filteredUsers" [value]="item" [title]="item.fullName + ' - ' + item.email">
                        <div class="user-option" matTooltip="{{ item.fullName }} - {{ item.email }}" >
                            <span class="user-label">
                                {{ item.fullName }} - {{ item.email }}
                            </span>
                        </div>
                    </mat-option>

                    <!-- Show "No results" when search has >= 3 chars but no results -->
                    <mat-option *ngIf="filteredUsers.length === 0 && getUserSearchInputValue().trim().length >= 3" disabled>
                        No users found
                    </mat-option>

                </mat-autocomplete>
            </button>
            <button mat-icon-button class="me-2"
                [disabled]="!hasActiveFilters"
                (click)="clearFilter()"
                [matTooltip]="hasActiveFilters ? 'Clear filters' : ''"
                aria-label="Clear filters">
                <mat-icon class="icon-filter" [ngClass]="{'icon-filter-disable': !hasActiveFilters}">restart_alt</mat-icon>
            </button>


        </div>
    </div>

    <div class="tabset activity-log">
        <div class="tab-panels">
            <div class="tab-panel" *ngIf="tableDataLength > 0";>
                <div class="card activity-title">
                    <span>Activity Log</span>
                </div>

                <div class="table-scroll-container" id="scrollcustom" appScrollTracker (scrolledBottom)="loadMoreData()" #tableScrollContainer >
                    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" >
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Name</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="cell-width">{{ row?.name }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef>Email</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="cell-width">{{ row?.email }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="organisationName" *ngIf="isMainSuperUser">
                            <th mat-header-cell *matHeaderCellDef>Organisation Name</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="cell-width">{{ row?.organisationName }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef> Date <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span>
                                
                                <mat-icon style="font-size: 19px; padding-left: 5px; cursor: pointer; vertical-align: middle;" class="clock-icon" matSuffix matTooltip="Use the clock to set the preferred time scale on this page: UTC or registered time." (click)="convertTime($event)" >schedule</mat-icon>
                                
                                
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="cell-width">
                                    {{ timezone === 'UTC' ? (row?.date | date:'dd/MM/yyyy - hh.mm a' : ' GMT') : (row?._displayDate || (row?.date | date:'dd/MM/yyyy - hh.mm a')) }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="latestAction">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let row">
                                 <div class="action-container">

                                    <mat-icon class="action-icon" [ngClass]="row.actionClass">
                                        {{ row.actionIcon }}
                                    </mat-icon>

                                    <div class="action-content">

                                        <div class="action-type">
                                            {{ row.type }}
                                        </div>

                                        <div class="action-label" [ngClass]="row.actionClass">
                                            {{ row.latestAction }}
                                        </div>

                                        <div class="sub-item" *ngIf="row?.products?.length" >
                                            {{ getProductText(row.products) }}
                                        </div>
                                    </div>

                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr
                            class="ph-no-capture element-row"
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>
                
            </div>
            <div class="no-data" *ngIf="tableDataLength === 0">
                <app-notask [activityLog]="hasActiveFilters ? 'filters-applied' : 'no-data'"></app-notask>
             </div>
        </div>
    </div>
</div>